import React from "react"

function PlusIcon({ color }) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05169 1.54538C9.05169 0.965875 8.58191 0.496094 8.00241 0.496094C7.42291 0.496094 6.95312 0.965875 6.95312 1.54538V7.44531H1.04928C0.469781 7.44531 0 7.91509 0 8.4946C0 9.0741 0.469781 9.54388 1.04928 9.54388H6.95312V15.4468C6.95312 16.0263 7.42291 16.4961 8.00241 16.4961C8.58191 16.4961 9.05169 16.0263 9.05169 15.4468V9.54388H14.9507C15.5302 9.54388 16 9.0741 16 8.4946C16 7.91509 15.5302 7.44531 14.9507 7.44531H9.05169V1.54538Z"
        fill={color || "#485AFF"}
      />
    </svg>
  )
}

export default PlusIcon
